import { render, staticRenderFns } from "./DocumentsBalances.vue?vue&type=template&id=55de39cc"
import script from "./DocumentsBalances.vue?vue&type=script&lang=ts"
export * from "./DocumentsBalances.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports